import React from 'react';
import './answer.scss';
import {firestore} from '../../../configs/environments/firebase/firebaseApp';


function Answer({ user, contacto }) {

const analyticBtn = (typeBtn) =>{

  firestore.collection("analytics").doc(user.uid).collection(typeBtn).add({
    createdAt : new Date(),
    lawyerUid: user.uid
  })

}

  const tituloNombre = (auth) => {
    switch (auth.gradeStudy) {
      case 'Licenciatura': {
        return 'Lic.';
      }
      case 'Maestría': {
        if (auth.genero == 'male') {
          return 'Mtro.';
        } else if (auth.genero == 'female') {
          return 'Mtra.';
        }
        return null;
      }
      case 'Especialidad':
        return 'Esp.';
      case 'Doctorado': {
        if (auth.genero == 'male') {
          return 'Dr.';
        } else if (auth.genero == 'female') {
          return 'Dra.';
        }
        return 'auth.gradeStudy ';
      }

      default:
        return '';
    }
  };

  const linkedInID = user && user.contacto && user.contacto.linkedIn ? user.contacto.linkedIn.split(/(\/in\/|company\/)/) : '';
  const siteName = user && user.contacto && user.contacto.blog ? user.contacto.blog.split(/(?:www\.|http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)/) : '';

  return (
    <>
      {user ? (
        <div>
          <article className="cardReply_timetable">
            <p>
              {user && user.role == 'lawFirm'? 
              user.officeName :
              user.lastName ?
              `${tituloNombre(user)} ${user.name ? user.name : ''} ${
                user.lastName ? user.lastName : ''
              }` :
              `${tituloNombre(user)} ${user.name ? user.name : ''} ${
                  user.firstLastName ? user.firstLastName : ''
                } ${user.secondLastName ? user.secondLastName : ''}`}
            </p>
           
          </article>

          {/* Contact Form reply on busqueda/abogado-despacho */}

          <div className="cardReply_reply">
            <p>Sus datos se enviaron correctamente</p>
          </div>

          <article className="cardReply_info">
            {user.contacto && user.contacto.whats && (
              <a
                onClick={()=>{
                  analyticBtn('whatsApp')
                }}
                href={`https://api.whatsapp.com/send?phone=52${user.contacto.whats}`}
                className="cardReply_link"
                target="_blank"
              >
                <div className="cardReply_data whats">
                  <figure className="cardReply_img">
                    <img src="/img/viewProfile/answer/whats.svg" alt="icono" />
                  </figure>
                  <div className="cardReply_flex">
                    <div className="cardReply_text">
                      <p>WhatsApp</p>
                      <p>{user.contacto.whats}</p>
                    </div>
                    <img className="cardReply_arrow" alt='enviar whatsapp' />
                  </div>
                </div>
              </a>
            )}

            {user && (
              <a
              onClick={()=>{
                  analyticBtn('mail')
                }}
                href={`mailto:${user.contacto && user.contacto.email? user.contacto.email: user.email}`}
                className="cardReply_link"
              >
                <div className="cardReply_data blue">
                  <figure className="cardReply_img">
                    <img src="/img/viewProfile/answer/correo.svg" alt="icono" />
                  </figure>
                  <div className="cardReply_flex">
                    <div className="cardReply_text">
                      <p>Correo</p>
                      <p> {user.contacto && user.contacto.email? user.contacto.email: user.email}</p>
                    </div>
                    <img className="cardReply_arrow" alt='enviar correo'/>
                  </div>
                </div>
              </a>
            )}

            {user.contacto && user.contacto.movil && (
              <a
              onClick={()=>{
                  analyticBtn('phone')
                }}
                href={`tel:${user.contacto.movil}`}
                className="cardReply_link"
              >
                <div className="cardReply_data blue">
                  <figure className="cardReply_img">
                    <img src="/img/viewProfile/answer/cel.svg" alt="icono" />
                  </figure>
                  <div className="cardReply_flex">
                    <div className="cardReply_text">
                      <p>Teléfono móvil</p>
                      <p>{user.contacto.movil}</p>
                    </div>
                    <img className="cardReply_arrow" alt='contactar por móvil' />
                  </div>
                </div>
              </a>
            )}

            {user && (
              <a
              onClick={()=>{
                  analyticBtn('phone')
                }}
                href={`tel:${user.contacto && user.contacto.phone? user.contacto.phone: user.phone}`}
                className="cardReply_link"
              >
                <div className="cardReply_data blue">
                  <figure className="cardReply_img">
                    <img src="/img/viewProfile/answer/telefono.svg" alt="icono" />
                  </figure>
                  <div className="cardReply_flex">
                    <div className="cardReply_text">
                      <p>Teléfono de oficina</p>
                      <p>{user.contacto && user.contacto.phone? user.contacto.phone: user.phone}</p>
                    </div>
                    <img className="cardReply_arrow" alt='llamar a oficina' />
                  </div>
                </div>
              </a>
            )}

            {user.contacto && user.contacto.linkedIn && (
              <a
                target="_blank"
                rel="noopener noreferrer nofollow"
                href={user.contacto.linkedIn}
                className="cardReply_link"
              >
                <div className="cardReply_data linkedin">
                  <figure className="cardReply_img">
                    <img src="/img/viewProfile/answer/linkedin.svg" alt="icono" />
                  </figure>
                  <div className="cardReply_flex">
                    <div className="cardReply_text">
                      <p>LinkedIn</p>
                      <p> {linkedInID[2]}</p>
                    </div>
                    <img className="cardReply_arrow" alt='contactar por linkedin' />
                  </div>
                </div>
              </a>
            )}

            {user.contacto && user.contacto.blog && (
              <a
              onClick={()=>{
                  analyticBtn('web')
                }}
                target="_blank"
                rel="noopener noreferrer nofollow"
                href={user.contacto.blog}
                className="cardReply_link"
              >
                <div className="cardReply_data blue">
                  <figure className="cardReply_img">
                    <img src="/img/viewProfile/answer/pagina-web.svg" alt="icono" />
                  </figure>
                  <div className="cardReply_flex">
                    <div className="cardReply_text">
                      <p>Sitio Web</p>
                      <p> {user.contacto.blog === siteName[0]? siteName[0]:siteName[1]}</p>
                    </div>
                    <img className="cardReply_arrow" alt='visitar sitio web' />
                  </div>
                </div>
              </a>
            )}
          </article>

          <footer className="cardReply_footer">
            <p>
              Al llenar el formulario de este abogado, sus datos se guardaran en
              tu bandeja para posteriores consultas.
            </p>
          </footer>
        </div>
      ) : null}
    </>
  );
}

export default Answer;
